import "./styles.scss";
import React, { FC } from "react";
import CompanyTeamItem from "./CompanyTeamItem";
import { useCompanyTeam } from "queryHooks";
// import { PsState } from "../../TrixtaComponents/store/paperstreetReducer";
// import { useSelector } from "react-redux";

// interface IState {
//   trixta: {};
//   paperstreet: PsState;
//   phoenix: {};
// }

interface IProps {
  company: { team: []; name: string; company_id: string };
}

const CompanyTeamContent: FC<IProps> = (props) => {
  const { company } = props;
  // const { paperstreet } = useSelector((state: IState) => state);
  // const { team } = company ? company : [];

  const { data: team = [] } = useCompanyTeam({ companyId: company.company_id });

  const makeTeamComponent = team.map((member, index) => {
    const fullName = `${member["first_name"]} ${member["last_name"]}`;
    return (
      <CompanyTeamItem
        key={index}
        avatar={member["profile_image_url"]}
        name={fullName}
        job={member["title"]}
        linkedin_url={member["linkedin_url"]}
        company={company}
      />
    );
  });

  return <div className="ps-company-team-content">{makeTeamComponent}</div>;
};

export default CompanyTeamContent;
